/**
 * @fileoverview Entity Picker entity item presentation component
 */
goog.declareModuleId('yext.ui.components.entitypicker.EntityItem');

import * as styles from '/ui/components/entitypicker/itemlist/itemlist.module.scss';

export function EntityItem(props) {
  const cssClass = `uep-item ${props.icon.itemClass} ${styles.uepItem}`;
  const attributes = props.icon.itemAttributes;
  return (
    <li className="uep-entity-item">
      <button type="button" onClick={props.onClick} className={cssClass} {...attributes}>
        <div className="uep-entity-labels">
          <span className="uep-entity-label">{props.entity.label}</span>
          <span className="uep-entity-sublabel">{props.entity.sublabel}</span>
        </div>
      </button>
    </li>
  );
}
